function extractAnswers() {
    const inputs = document.querySelectorAll('.input-wrapper input[type="radio"]');
    const questions = {};
    inputs.forEach(input => {
        const handle = input.getAttribute('data-handle'); // Extract handle
        const group = input.getAttribute('data-group');   // Extract group
        const value = input.value;                        // Extract point (value)
        const name = input.name;                          // Extract question name
        // Initialize the question if it doesn't exist
        if (!questions[name]) {
            questions[name] = {};
            questions[name]['priority'] = input.getAttribute('data-priority');
        }
        // Add the handle as a sub-item with group and point
        questions[name][handle] = {
            group: group,
            point: parseInt(value, 10) // Convert value to integer
        };
    });
    return questions;
}

function getCheckedRadioValues(formSelector) {
    const form = document.querySelector(formSelector);
    const checkedValues = {}
    if (!form) {
        console.warn(`Form not found at selector: ${formSelector}`);
        return checkedValues;
    }
    form.querySelectorAll('input.validQuestion:checked').forEach(input => {
        checkedValues[input.name] = input.getAttribute('data-handle');
    });

    return checkedValues;
}

function calculateWidth() {
    const steps = document.querySelectorAll(".step");
    const completedSteps = document.querySelectorAll(".step.complete");
    const progressBar = document.querySelector(".completed_progress");
    if (steps.length === 0) return;

    // Calculate progress percentage
    const progress = Math.max(0, Math.min(100, (completedSteps.length / (steps.length - 1)) * 100));
    // Update the progress bar width
    progressBar.style.width = progress + "%";
}

function updateURLParams(param, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(param, value); // Set or update the parameter
    window.history.pushState({ path: url.href }, "", url.href);
}

function getRiskLevel(totalPoints) {
    if (totalPoints <= 4) {
        return "low-risk";
    } else if (totalPoints >= 5 && totalPoints <= 8) {
        return "moderate-risk";
    } else if (totalPoints >= 9) {
        return "high-risk";
    } else {
        return "low-risk";
    }
}

function sendDataToMake(payload) {
    if (typeof payload !== 'object' || payload === null) {
        console.error("❌ Invalid payload passed to sendDataToMake:", payload);
        return;
    }
    fetch("https://hook.us2.make.com/5wgy30h74jq0cp6ce4ppduta3x412mix", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    })
        .then(response => {
            if (response.ok) {
                console.log("✅ Data sent to webhook successfully!");
                localStorage.removeItem('userEmail'); // Optional cleanup
            } else {
                console.error("❌ Failed to send data to webhook", response.status);
            }
        })
        .catch(error => {
            console.error("❌ Webhook fetch error:", error);
        });
}

window.sendQuizDataToWebhook = function (mailchimpHostId, formType) {
    const mailchimpHost = document.querySelector(`#${mailchimpHostId}`);
    let phoneInputValue = null;
    let countryPhone = 'US';
    const storedEmail = localStorage.getItem('userEmail') || null;
    const userName = document.getElementById('first-name')?.value?.trim() || null;
    if (mailchimpHost) {
        // const shadowRoot = mailchimpHost.shadowRoot;
        const phoneInputEl = mailchimpHost.querySelector('input[name="phone"]');
        phoneInputValue = phoneInputEl?.value?.trim() || null;
        const countrySelect = mailchimpHost.querySelector('div.PhoneInputCountry select');
        if (countrySelect?.value?.trim()) {
            countryPhone = countrySelect.value.trim();
        }
    } else {
        console.warn("Mailchimp shadow root not found.");
    }

    const checkedValuesForm = getCheckedRadioValues(".question-list-wrapper");
    let finalResult = null;
    if (formType == 'sleep-apnea') {
        let questions = extractAnswers();
        let totalPoints = 0;
        const userResponses = getCheckedRadioValues(".question-list-wrapper");
        // Assign scores based on user responses
        for (const question in userResponses) {
            const answer = userResponses[question];
            if (questions[question] && questions[question][answer]) {
                const { group, point } = questions[question][answer];
                totalPoints += point;
            }
        }
        finalResult = getRiskLevel(totalPoints) + "(" + totalPoints + ")";
    }
    const payload = {
        formtype: formType || "Unknown",
        name: userName || null,
        email: storedEmail,
        phone: phoneInputValue,
        country: countryPhone,
        result: finalResult,
        quizAnswers: checkedValuesForm
    };

    sendDataToMake(payload);
};

function UpdateMasterSelectVariant(card, selected_options) {
    let variants_list = card.querySelectorAll('.variants-values li');
    let options_items = card.querySelectorAll('.variant-option-selection');
    let variant_id = '';
    variants_list.forEach((item) => {
        if (item.getAttribute('data-name').trim().includes(selected_options.trim())) {
            // change select element option based on item data-id attribute
            variant_id = item.getAttribute('data-id');
        }
    });
    return variant_id;
}

document.addEventListener("DOMContentLoaded", function () {
    const productCards = document.querySelectorAll('.product-box'); // Replace with your card's class name
    productCards.forEach((card) => {
        const selectElements = card.querySelectorAll('.variant-option-selection');
        selectElements.forEach((select) => {
            select.addEventListener('change', function (event) {
                const parentContent = event.target.closest('.product-box');
                let productId = this.dataset.productid;
                let selectedOptions = '';
                let allSelected = true;
                selectElements.forEach((selects) => {
                    if (selects.value == '') {
                        allSelected = false;
                    } else {
                        selectedOptions += selects.value + ' '
                    }
                });
                let properties = this.dataset.properties;
                const cartButton = card.querySelector('.collection-add-to-cart');
                if (selectedOptions !== '' && allSelected) {
                    let variant_id = UpdateMasterSelectVariant(card, selectedOptions);
                    if (variant_id !== '' && productId != '') {
                        let variantJson = JSON.parse(card.querySelector(".product-" + productId).textContent);
                        let selectedVariantJSON = variantJson.find((variant) => {
                            return variant.id == variant_id
                        });
                        if (selectedVariantJSON) {
                            parentContent.querySelector('.sp-product-card__price-sale.original-price').innerHTML = theme.Currency.formatMoney(selectedVariantJSON.price, theme.settings.moneyFormat)
                            parentContent.querySelector('.sp-product-card__price-original.current-price').innerHTML = theme.Currency.formatMoney(selectedVariantJSON.price, theme.settings.moneyFormat)
                            applyDiscountCode(parentContent)
                            if (!selectedVariantJSON.available) {
                                cartButton.classList.add('sold-out-btn')
                                cartButton.setAttribute('disabled', 'disabled')
                                cartButton.innerHTML = cartButton.dataset.soldout;
                            } else {
                                cartButton.classList.remove('sold-out-btn')
                                cartButton.removeAttribute("disabled");
                                cartButton.innerHTML = cartButton.dataset.addtocart;
                            }
                        }
                        cartButton.setAttribute(
                            'onclick',
                            `event.preventDefault();document.querySelector('ajax-cart').addToCartMultiple('${variant_id}',1,{"${properties}":1})`
                        );
                    }
                }
            })
        })
    })
});